import { useStore } from "@/store";

import type { DocumentModel } from "@/models/DocumentModel";

// TODO: move this logic to BE
// https://linear.app/corca-research/issue/D-1320/move-showpublictoggle-to-be
/**
 * Returns true if the document belongs to one of the current user's teams.
 */
export function useIsMyDoc(doc?: DocumentModel): boolean {
  const { teams } = useStore();
  if (!doc) return false;

  return !!(
    teams?.userTeams &&
    doc.api.team &&
    teams.userTeams.some(({ uid }) => uid === doc.api.team?.uid)
  );
}
